import { render } from "./CreateServiceReport3.vue?vue&type=template&id=63180ff4"
import script from "./CreateServiceReport3.vue?vue&type=script&lang=js"
export * from "./CreateServiceReport3.vue?vue&type=script&lang=js"

import "./CreateServiceReport3.vue?vue&type=style&index=0&id=63180ff4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__